<template>
  <div>
    <div class="notification is-info" v-if="!hasAdmins">GPS has no admins.</div>

    <button class="button is-success is-fullwidth is-outlined add-admin" @click="addAdmin()">
      Add Admin
    </button>

    <table class="table is-fullwidth is-striped" v-if="hasAdmins">
      <thead>
        <tr>
          <th></th>
          <th>Email</th>
          <th>Is Dog Handler of Active Dog</th>
          <th>Id</th>
          <th>Name</th>
        </tr>
      </thead>

      <tbody>
        <tr v-for="adminUserId in adminUserIds" :key="adminUserId">
          <td>
            <button
              v-if="gpsAdminUser(adminUserId)"
              class="button is-text is-size-6 has-text-danger"
              @click="removeAdmin(adminUserId)"
            >
              Remove
            </button>
          </td>
          <td>
            <span v-if="gpsAdminUser(adminUserId)">{{ gpsAdminUser(adminUserId).email }}</span>
          </td>
          <td>
            <span :class="isDogHandlerTextClass(adminUserId)">{{
              isDogHandlerText(adminUserId)
            }}</span>
          </td>

          <td>
            <span>{{ adminUserId }}_LLUser</span>
          </td>
          <td>
            <span v-if="gpsAdminUser(adminUserId)"
              >{{ gpsAdminUser(adminUserId).firstName }}
              {{ gpsAdminUser(adminUserId).lastName }}</span
            >
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { LOAD_USERS_WITH_IDS, GET_USER_WITH_ID } from '@/modules/users/usersCacheStore.js'

export default {
  name: 'GPSDeviceAdminsTab',

  components: {},

  props: {
    adminUserIds: {
      type: Array,
      required: true
    },
    usersCacheStorePath: {
      type: String,
      required: true
    },
    activeDogProfile: {
      type: Object,
      required: false
    }
  },

  mounted() {
    this.loadAdminUsers()
  },

  methods: {
    loadAdminUsers() {
      if (!this.adminUserIds) {
        return
      }

      const loadUserWithIdsAction = `${this.usersCacheStorePath}/${LOAD_USERS_WITH_IDS}`
      this.$store.dispatch(loadUserWithIdsAction, { userIds: this.adminUserIds })
    },

    gpsAdminUser(userId) {
      const getUserWithIdPath = `${this.usersCacheStorePath}/${GET_USER_WITH_ID}`
      return this.$store.getters[getUserWithIdPath](userId)
    },

    addAdmin() {
      this.$emit('add-admin')
    },

    removeAdmin(adminUserId) {
      const adminUser = this.gpsAdminUser(adminUserId)
      if (!adminUser) {
        return
      }

      this.$emit('remove-admin', adminUser)
    },

    isDogHandlerText(adminUserId) {
      if (!this.activeDogProfile) {
        return ''
      }

      return this.activeDogProfile.dogHandlerUserIds.includes(adminUserId) ? 'YES' : 'NO'
    },

    isDogHandlerTextClass(adminUserId) {
      const isDogHandler = this.isDogHandlerText(adminUserId) === 'YES'

      return {
        'has-text-danger': !isDogHandler,
        'has-text-success': isDogHandler
      }
    }
  },

  computed: {
    hasAdmins() {
      return this.adminUserIds && this.adminUserIds.length > 0
    }
  }
}
</script>

<style lang="scss" scoped>
.table td {
  border-bottom: 0;
}

td span {
  white-space: nowrap;
}

td .button {
  padding: 0px;
  height: 1.5em;
}

.button.add-admin {
  margin-bottom: 1em;
}
</style>
